import { createContext, useContext } from "react";

export const ConfigContext = createContext(undefined);

export const useConfig = () => {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error("ConfigContext is not provided");
  }

  return context;
};
